import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertModule } from 'src/app/shared/components/alert/alert.module';
import { ProductChangeModule } from 'src/app/shared/components/product-change/product-change.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { PackageModule } from 'src/app/shared/components/package/package.module';
import { ProductModule } from 'src/app/shared/components/product/product.module';

import { ChangePlanComponent } from './change-plan.component';
import { HeroModule } from 'src/app/shared/components/hero/hero.module';



@NgModule({
  declarations: [
    ChangePlanComponent
  ],
  exports: [
    ChangePlanComponent
  ],
  imports: [
    CommonModule,
    AlertModule,
    ProductChangeModule,
    
    MatIconModule,
    MatDividerModule,
    PackageModule,
    ProductModule,
    MatIconModule,
    HeroModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ChangePlanModule { }
